import { IndividualsDuplexerChannel } from '@wix/ai-scheduling-assistant-common-lib/commonTypes';
import { useDuplexerSubscription } from './use-duplexer-subscription';

/**
 * A server→client UI command from Orion (the harness ClientControl tool),
 * delivered on the `individuals-client-control` channel. Mirror of the harness
 * ClientControlCommand; fields are optional here since it's an untrusted wire
 * payload. HTTPS-only (see useDuplexerSubscription).
 */
export interface ClientControlCommand {
  action?: string;
  conversationId?: string;
  // action === 'navigate': per-surface targets resolved by the harness. Web opens `link.desktop`
  // (a basePath-relative path); absent = nothing to open on web (graceful no-op).
  link?: { desktop?: string; mobile?: string };
  // action === 'navigate' to phone verification: the national part, to seed the field with.
  phone?: string;
  // action === 'widget-edit': the widget `slug` and whether Orion is currently working on it.
  slug?: string;
  editing?: boolean;
}

export function useClientControlDuplexer(onCommand: (command: ClientControlCommand) => void) {
  useDuplexerSubscription<ClientControlCommand>(IndividualsDuplexerChannel.CLIENT_CONTROL, (payload) => {
    if (payload.entity) onCommand(payload.entity);
  });
}
